import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import Switch from 'react-switch';

// Componentes
import TextField from '../../../../../components/TextField';

// Context
import { useAuth } from '../../../../../context/auth';

// API
import funcionalidades_api from "../../../../../api/funcionalidades_api";
import { showMessage } from '../../../../../helpers/message';
import perfil_api from '../../../../../api/perfil_api';

function PermissoesPerfil({ perfil, setPerfil, handleVoltar, editavel }) {
    const { setLoading } = useAuth();

    // state para funcionalidade e Acoes
    const [funcionalidadesAcoes, setFuncionalidadesAcoes] = useState([]);

    //Função para carregar as funcionalidades do sistema
    const loadFuncionalidadesComAcoes = () => {
        setLoading(true);
        funcionalidades_api.getList().then(response => {
            setFuncionalidadesAcoes(response.data);
        })
            .catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadFuncionalidadesComAcoes();
    }, []);

    //Função de onChange dos campos
    const onChange = (e, acao_id) => {
        const _funcionalidadeAcos = perfil.funcionalidadeAcos.map(funcionalidadeAco => {
            if (funcionalidadeAco.funcionalidadeAcao_Id === acao_id) {
                return {
                    ...funcionalidadeAco,
                    autorizado: e
                };
            }
            return funcionalidadeAco;
        });

        // Se não houver nenhuma correspondência para o acao_id, adiciona um novo objeto
        if (!_funcionalidadeAcos.some(funcionalidadeAco => funcionalidadeAco.funcionalidadeAcao_Id === acao_id)) {
            _funcionalidadeAcos.push({
                funcionalidadeAcao_Id: acao_id,
                autorizado: e
            });
        }

        setPerfil({
            ...perfil,
            funcionalidadeAcos: _funcionalidadeAcos
        });
    };

    //Função para salvar as permissões
    const handleSalvarPermissoes = () => {
        if (perfil?.funcionalidadeAcos?.length == 0) {
            showMessage("Aviso", "sem permissoes para salvar.", "error", null);
            return;
        }

        const _permissoes = perfil.funcionalidadeAcos.filter(v => v.autorizado);

        setLoading(true);
        perfil_api.PostPermissoes(perfil.id, _permissoes)
            .then(response => {
                showMessage("Sucesso", "Sucesso ao salvar as permissões.", "success", null);
            })
            .catch(err => showMessage("Error", err.message, "error", null))
            .finally(() => setLoading(false));
    }


    return <>
        <Row>
            <h5 className='mb-3'>Lista de Permissões</h5>
        </Row>
        <Row className='d-flex justify-content-start align-items-center mb-4'>
            {funcionalidadesAcoes?.map((value, key) => (
                <Col lg="4" md="6" sm="12" className='mb-3 ' key={key}>
                    <Card>
                        <CardHeader>{value.descricao}</CardHeader>
                        <CardBody>
                            <Row>
                                {value?.funcionalidadeAcos?.map((acoes, key2) => (
                                    <Col lg="12" md="12" sm="12" key={key2}>
                                        <FormGroup className='d-flex align-items-center'>
                                            <label htmlFor={acoes.funcionalidadeAcao_Id} className='d-flex align-items-center justify-content-center gap-2'>
                                                <Switch
                                                    id={acoes.funcionalidadeAcao_Id.toString()}
                                                    className="react-switch"
                                                    checked={perfil.funcionalidadeAcos.filter(v => v.funcionalidadeAcao_Id == acoes.funcionalidadeAcao_Id)[0]?.autorizado ?? false}
                                                    onChange={e => onChange(e, acoes.funcionalidadeAcao_Id)}
                                                    onColor="#86d3ff"
                                                    disabled={!editavel}
                                                    onHandleColor="#2693e6"
                                                />
                                                <span>{acoes.acao}</span>
                                            </label>
                                        </FormGroup>
                                    </Col>
                                ))}
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
        <Row>
            {editavel &&
                <Col md="12" lg="12" className='d-flex align-items-center justify-content-center '>
                    <Button
                        color='success'
                        className='px-4'
                        onClick={handleSalvarPermissoes}
                    >
                        <FontAwesomeIcon icon={faSave} /> Salvar
                    </Button>
                </Col>
            }
        </Row>
    </>;
}

export default PermissoesPerfil;